'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveOnChannel = isActiveOnChannel;

var _getIsInForeground = require('./getIsInForeground');

function isActiveOnChannel(state, channel) {
  var currentChannel = state.currentChannel;

  return channel === currentChannel && (0, _getIsInForeground.getIsInForeground)(state);
}


//////////////////
// WEBPACK FOOTER
// ./js/selectors/clientSelectors/isActiveOnChannel.js
// module id = 431
// module chunks = 2 3